// src/router/index.ts
import { createRouter, createWebHistory } from "vue-router";

import Login from "../Pages/LoginPage.vue";
import Dashboard from "../Pages/Dashboard.vue";
import Invoice from "../Pages/Invoice.vue";
import Transaksi from "../Pages/Transaksi.vue";
import Orders from "../Pages/OrdersList.vue";

import ProductMaster from "../Pages/Products.vue";
import DeliveryMaster from "../Pages/DeliveryMethodsList.vue";
import PollMaster from "../Pages/PollsList.vue";
import CustomerMaster from "../Pages/Customer.vue";
import Report from "../Pages/Report.vue";
import ConsignmentStockPage from "../Pages/ConsignmentStockPage.vue";
import AdminLayout from "../components/Layouts/AdminLayout.vue";
import InvoiceDownload from "../Pages/InvoiceDownload.vue";

const routes = [
  // =============================
  // LOGIN PAGE
  // =============================
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  // =============================
  // APP PANEL (USER + ADMIN)
  // =============================
  {
    path: "/app",
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      // USER + ADMIN ACCESS
      { path: "dashboard", name: "Dashboard", component: Dashboard },
      { path: "invoice", name: "Invoice", component: Invoice },
      { path: "transaksi", name: "Transaksi", component: Transaksi },
      { path: "orders", name: "OrdersList", component: Orders },
      {
        path: "/invoice-download",
        name: "InvoiceDownload",
        component: InvoiceDownload,
      },
      {
        path: "production",
        name: "ProductionList",
        component: () => import("@/Pages/ProductionList.vue"),
      },

      // ADMIN ONLY
      {
        path: "products",
        name: "Products",
        component: ProductMaster,
        meta: { requiresAdmin: true },
      },
      {
        path: "customers",
        name: "Customers",
        component: CustomerMaster,
        meta: { requiresAdmin: true },
      },
      {
        path: "delivery-methods",
        name: "DeliveryMethods",
        component: DeliveryMaster,
        meta: { requiresAdmin: true },
      },
      {
        path: "polls",
        name: "Polls",
        component: PollMaster,
        meta: { requiresAdmin: true },
      },
      {
        path: "report",
        name: "Report",
        component: Report,
        meta: { requiresAdmin: true },
      },
      { path: "consignment-stock", 
        name: "ConsignmentStock", 
        component: ConsignmentStockPage, 
        meta: { requiresAdmin: true } 
      }
    ],
  },

  // =============================
  // DEFAULT REDIRECT
  // =============================
  {
    path: "/",
    redirect: "/login",
  },

  // =============================
  // FALLBACK
  // =============================
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// =============================
// ROUTE GUARD
// =============================
router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("loggedIn") === "true";
  const user = JSON.parse(localStorage.getItem("user") || "null");

  // AUTH CHECK
  if (to.meta.requiresAuth && !loggedIn) {
    next("/login");
    return;
  }

  // ADMIN CHECK
  if (to.meta.requiresAdmin) {
    if (!user || Number(user.role) !== 0) {
      next("/app/dashboard");
      return;
    }
  }

  next();
});

export default router;